module.exports = __webpack_public_path__ + "img/icon_sm_xqqs.cd8caf1d.png";